<template>
  <Content title="成功客户案例">
    <div id="caseCarousel" class="carousel slide" data-ride="carousel" data-interval="false">
      <div class="carousel-inner h-100">
        <div
          v-for="(caseItem, i) in cases"
          :key="i"
          class="carousel-item case-item th-px-45"
          :class="{ active: i === 0 }"
        >
          <div class="th-px-15 th-py-25 bg-white">
            <img :src="caseItem.image" />
            <div class="th-fs-13 th-mt-40 th-px-10">{{ caseItem.desc }}</div>
          </div>
        </div>
      </div>
      <a class="carousel-control-prev" href="#caseCarousel" role="button" data-slide="prev">
        <span class="carousel-preview-btn" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#caseCarousel" role="button" data-slide="next">
        <span class="carousel-next-btn" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
import { cases } from './data'
export default {
  name: 'MobileSuccessCase',
  components: { Content },
  setup() {
    return { cases }
  },
}
</script>

<style lang="scss" scoped>
.case-item {
  img {
    width: 100%;
    height: 120px;
    object-fit: contain;
  }
}
</style>
